import { lazyWithChunkReload } from "../../shared/lib/chunk-load-recovery";

export const DocumentsPage = lazyWithChunkReload(() =>
  import("./pages/documents.main").then((m) => ({ default: m.DocumentsPage }))
);
